import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject, takeUntil } from 'rxjs';
import { AuthenticationService, User } from '../../services/authentication.service';
import { NotificationService } from '../../services/notification.service';

@Component({
	selector: 'app-main-header',
	templateUrl: './main-header.component.html',
	styleUrls: ['./main-header.component.scss'],
})
export class MainHeaderComponent implements OnInit, OnDestroy {
	userIsAuthenticated: boolean = false;
	notificationBadgeCount$!: Observable<number>;
	authUser$!: Observable<User | null>;
	private _unsubscribeAll: Subject<void> = new Subject<void>();

	constructor(
		private authenticationService: AuthenticationService,
		private notificationService: NotificationService,
	) {}

	ngOnInit() {
		this.authUser$ = this.authenticationService.authUser$;
		this.authenticationService.authUser$.pipe(takeUntil(this._unsubscribeAll)).subscribe({
			next: user => {
				this.userIsAuthenticated = !!user;
			},
		});
		this.notificationBadgeCount$ = this.notificationService.notificationBadgeCount$;
	}

	ngOnDestroy(): void {
		// Unsubscribe from all subscriptions
		this._unsubscribeAll.next();
		this._unsubscribeAll.complete();
	}
}
